import { Stack, Box } from "@mui/material";
import React, { useEffect } from "react";
import {
  FontStyle,
  QuestionData,
  defaultInnerStyle,
  defaultContainerStyle,
} from "../../constants";
import HeartButton from "../HeartButton";
import SlideTransition from "../SlideTransition";

const styles = {
  container: {
    width: "100%",
    height: "100%",
    paddingTop: "23px",
  },
  inner: {
    maxWidth: "530px",
  },
  subtitle: {
    ...FontStyle.body,
    fontSize: "0.83rem",
    textAlign: "center",
  },
};
const numNeeded = 1;
const numMax = 3;

const Q0_Important = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
}) => {
  useEffect(() => {
    if (
      selected[questionNum].length >= numNeeded &&
      selected[questionNum].length <= numMax
    ) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }));
    }
  }, [selected]);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      alignItems="center"
      spacing={2}>
      <Box sx={styles.subtitle}>
        You can choose {numMax - selected[questionNum].length} more
      </Box>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        sx={styles.inner}
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        spacing={1}
        gap={{ xs: 0, sm: 1 }}>
        {options.map((option, i) => {
          return (
            <HeartButton
              key={i}
              text={option}
              selected={selected[questionNum].includes(i)}
              setSelected={() => {
                if (selected[questionNum].includes(i)) {
                  setSelected((s) => {
                    return {
                      ...s,
                      [questionNum]: s[questionNum].filter(
                        (item) => item !== i
                      ),
                    };
                  });
                } else if (selected[questionNum].length < numMax) {
                  setSelected((s) => {
                    return { ...s, [questionNum]: [...s[questionNum], i] };
                  });
                }
              }}
              disabled={
                selected[questionNum].length >= numMax &&
                !selected[questionNum].includes(i)
              }
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default Q0_Important;
